// Central app config for non-auth settings
import { APP_CONFIG } from "./runtime-config";
function sanitizeBaseUrl(raw) {
    if (!raw)
        return "";
    let url = String(raw).trim();
    // Guard against accidental concatenation like '.../apiREACT_APP_ENV=development'
    const idx = url.indexOf("REACT_APP_");
    if (idx > -1)
        url = url.slice(0, idx);
    // Remove trailing junk after whitespace
    url = url.split(/\s/)[0];
    // Ensure single trailing slash
    if (!url.endsWith("/"))
        url += "/";
    return url;
}
export const API_BASE_URL = sanitizeBaseUrl(APP_CONFIG.API_URL);
